import React from 'react';
import '../Connect/Connect.css';
import { Link } from 'react-router-dom';

const Connect = () => {
  return (
    <section className="connect-section">
      <div className="connect-box">
        <h1 className="connect-heading">
          Travel is a World Leading Online Tour<br />Booking Platform
        </h1>
        <Link to="/tour">
        <button className="connect-button">Book Now</button>
        </Link>
      </div>
    </section>
  );
};

export default Connect;
